module.exports = __webpack_public_path__ + "img/logorealtec-w.d01cb127.svg";